module.exports = __webpack_public_path__ + "img/icon-search-button.691866ad.png";